import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md text-center">
        <h1 className="text-2xl font-bold text-gray-800">About Shehrullah Khidmat</h1>
        <p className="text-gray-600 mt-2">
          Shehrullah Khidmat is a volunteer management application designed to
          streamline the registration and coordination of volunteers for community
          service activities.
        </p>

        <Link
          to="/"
          className="inline-block mt-4 px-6 py-2 text-white bg-green-600 rounded-lg text-lg hover:bg-green-700"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
